import React from 'react'
import { Dialog } from 'hhsoig-design-system-core'

export const withBackButtonProtection = (WrappedComponent, base) => {
  return class extends React.Component { //eslint-disable-line
    constructor(props) {
      super(props)
      this.state = {
        showModal: false
      }
      this.registerBackButtonHandler = this.registerBackButtonHandler.bind(this)
      this.displayModal = this.displayModal.bind(this)
      this.hideModal = this.hideModal.bind(this)
      this.showModal = this.showModal.bind(this)
    }

    hideModal() {
      this.setState({ showModal: false })
    }

    showModal() {
      this.setState({ showModal: true })
    }

    registerBackButtonHandler() {
      // Below call to history.pushState is needed to prevent the user from going back to home page on a back button click.
      // If we don't have this call, the componentWillUnmount will be executed on a back button click, and the event handler will
      // be disabled. The Modal dialog will never get displayed.
      // With this call in place, even if the user clicks the back button, the browser history will have another entry for
      // this form's url and will stay on the same page and the onpopstate handler, defined below, will be invoked.
      //
      // Here's a link that shows how the pushState and replaceState calls work:
      // http://blogs.sitepointstatic.com/examples/tech/history-pushstate/index.html
      history.pushState(null, null, location.href)
      window.onpopstate = () => {
        history.forward() // make sure history still contains the same two url entries for this form's url as it did when the form loaded.
        this.showModal()
      }
    }

    displayModal = () =>
      this.state.showModal && (
        <Dialog
          onExit={this.hideModal}
          getApplicationNode={() => document.getElementById('MainForm')}
          title="Leave form"
          actions={[
            <button
              id="CancelBtn"
              className="ds-c-button"
              key="cancel"
              onClick={this.hideModal}
            >
              No, stay on the form
            </button>,
            <button
              id="BackBtn"
              className="ds-c-button ds-c-button--primary ds-u-margin-left--2"
              key="primary"
              onClick={() => {
                if (base) {
                  this.props.history.push(base)
                } else {
                  // Normal back button behavior if no base specified
                  history.go(-2)
                }
              }}
            >
              Yes, leave the form
            </button>
          ]}
        >
          Are you sure you want to leave the form and return to Hotline
          operations home? Your progress will be lost if you go back.
        </Dialog>
      )

    componentDidMount() {
      this.registerBackButtonHandler()
    }

    componentWillUnmount() {
      window.onpopstate = () => {}
    }

    render() {
      return (
        <React.Fragment>
          <WrappedComponent {...this.props} />
          {this.displayModal()}
        </React.Fragment>
      )
    }
  }
}

export default withBackButtonProtection
